import { widePanelTypes, fitContentOnlyPanelTypes } from '../../../panels/panelSchema';
import config from '../../../../config';

const { onPremise } = config;

/**
 * Check if section can have multiple columns
 * @param {Array} columns - Array of column objects
 * @returns {Object} { allowed: boolean, reason: string|null }
 */
export const canAddColumn = (columns) => {
  // Check if any existing column has a wide panel (Alarm or Event Timeline)
  const hasWidePanels = columns.some((column) =>
    column.panels?.some((panel) => widePanelTypes.has(panel.type))
  );

  // If there are already 2 columns and wide panels exist, prevent adding 3rd column
  // (because 3+ columns make all columns narrow at 33.33% or less)
  if (columns.length >= 2 && hasWidePanels) {
    return {
      allowed: false,
      reason:
        'Cannot add more columns. Section contains Alarm or Event Timeline panels which require wide columns.',
    };
  }

  return {
    allowed: true,
    reason: null,
  };
};

/**
 * Check if section height can be changed
 * @param {string} newHeight - New height value to set
 * @param {Array} columns - Array of column objects
 * @returns {Object} { allowed: boolean, reason: string|null }
 */
export const canChangeSectionHeight = (newHeight, columns) => {
  if (newHeight === 'fit-content') {
    return { allowed: true, reason: null };
  }

  const hasFitContentOnlyPanel = columns.some((column) =>
    column.panels?.some((panel) => fitContentOnlyPanelTypes.has(panel.type))
  );

  if (hasFitContentOnlyPanel) {
    return {
      allowed: false,
      reason: `Section contains panels (Visualizations, Event Timeline,${!onPremise ? ' Files, TFR Viewer,' : ''} Status, or Component Attributes) which only work with "Fit content" height.`,
    };
  }

  return { allowed: true, reason: null };
};
